import DOMActor from "../../Libs/Vexr/DOMActor";
import PumpkinTemplate from "../Pumpkin.ejs";
import Vector2 from "../../Libs/Vexr/Vector2";
import Screen from "../../Utils/Screen";
import Behaviors from "../../Libs/Vexr/Behaviors";

export default class VotingItem extends DOMActor{
    constructor(data) {
        super("VotingItem", new Vector2(Screen.getAnchor("center").x), -500);
        this.scale = 0.9;
        this.data = data;
        this.voted = false;
        this.position = null;
        this.selected = false;
        this.element.classList.add(data.key);
        this.element.classList.add("hide");
        this.element.innerHTML = PumpkinTemplate(data);

        this.updateAngle = (1 - Math.random())*3;
        this.catapultDir = new Vector2(
            Vector2.map(Math.random(),0,1,-5,5),
            Vector2.map(Math.random(),0,1,-25,-15));
        this.gravity = new Vector2(0,1);
        this.makeSelection = null;
        this.overeffect = this.over.bind(this);
        this.outeffect = this.out.bind(this);
        this.mousedown = this.down.bind(this);

        this.image = this.element.getElementsByTagName("img")[0];
        this.render();

    }

    show() {
        this.element.classList.remove("hide");
        this.element.classList.add("show");
    }
    hide () {
        this.element.classList.add("hide");
        this.element.classList.remove("show");
    }

    over () {
        this.scale += 0.2;
        this.angle = ((Math.random()*2)-1)*5;
        this.render();
    }

    out () {
        this.angle = 0;
        this.scale = 0.9;
        this.render();
    }

    down () {
        this.scale = 0.8;
        this.render();
    }

    move () {
        this.angle += this.updateAngle;
        this.addForce(this.gravity);
        Behaviors.destroyOutside(this, 0,0, Screen.dimensions.x, Screen.dimensions.y, 1000);
    }
    draw() {
        this.element.style.transform = `translateX(${this.location.x}px) translateY(${this.location.y}px) translateZ(0.1px)`;
        this.image.style.transform = `rotate(${this.angle}deg) scale(${this.scale})`;
    }
}


// WEBPACK FOOTER //
// ./src/views/Components/VotingItem.js